import fetch from "../fetch";

export default ({ dealCode, id }) =>
  fetch({
    method: "DELETE",
    path: `/cmbs/deals/${dealCode}/underwriters/${id}`
  });
